
/**
 * Global Variables:
 */
const extensionOptions = ['png', 'jpg', 'jpeg']
const defaultScoutLogoPath = "/static/SCOUT/Scout Default.png"

let surveyNameFromURL;
let projectNameFromURL;
let programNameFromURL;

let checkProjectFolder;
let project;
let program;
let imagePath;
let fileExtension = '';

/**
 * Methods:
 */
const toUpperCase = (name) => {
  return name.toUpperCase()
}

const setInitialImageFilePathAndProgramFromURL = (routerParams) => {
  programNameFromURL = routerParams.program_name.replace(/_/g, " ");
  imagePath = '/static/' + programNameFromURL + "/"
}

const setProjectAndSurveyNamesFromURL = (routerParams) => {
  projectNameFromURL = routerParams.project_name.replace(/_/g, " ");
  surveyNameFromURL = routerParams.survey_name.replace(/_/g, " ");
}

const setProgramProjectSurveyObjects = (programs, projects, surveys) => {
  program = programs.find(program => toUpperCase(program.name) === toUpperCase(programNameFromURL))
  project = projects.find(project => toUpperCase(project.name) === toUpperCase(projectNameFromURL) && project.program === program.pk)
  surveys.find(survey => toUpperCase(survey.name) === toUpperCase(surveyNameFromURL) && survey.project === project.pk)
}

const getFileExtension = (component, checkProjectFolder) => {
  let ext = null;
  for (let i = 0; i < extensionOptions.length; i++) {
    try {
      if (!checkProjectFolder) {
        require('../../public/static/' + programNameFromURL + '/' + component + '.' + extensionOptions[i])
        ext = extensionOptions[i]
      } else {
        require('../../public/static/' + programNameFromURL + '/' + projectNameFromURL + '/' + component + '.' + extensionOptions[i])
        ext = extensionOptions[i]
      }
    } catch (err) {
      if (err.code !== 'MODULE_NOT_FOUND') {
        /* eslint-disable */
        console.log(err);
        /* eslint-enable */
      }
    }
    return ext
  }
}

const showBrandingBasedOnSingleSurveyURL = (component) => {
  fileExtension = getFileExtension(component, true)
  if (!fileExtension) {
    fileExtension = getFileExtension(component, false)
    if (fileExtension) {
      checkProjectFolder = false;
      return true
    }
  } else {
    checkProjectFolder = true;
    return true
  }
  return false
}

const showBrandingBasedOnMultiSurveyURL = (component) => {
  fileExtension = getFileExtension(component, false)
  if (fileExtension) {
    checkProjectFolder = false;
    return true
  }
  return false
}


const showBrandingForComponent = (routerParams, programs, projects, surveys, component, hasCompleted) => {
  if (hasCompleted) {
    return false
  }
  setInitialImageFilePathAndProgramFromURL(routerParams)
  if (Object.keys(routerParams).length > 1) {
    setProjectAndSurveyNamesFromURL(routerParams)
    setProgramProjectSurveyObjects(programs, projects, surveys)
    return showBrandingBasedOnSingleSurveyURL(component)
  } else {
    return showBrandingBasedOnMultiSurveyURL(component)
  }
}

const getBrandingImageFilePath = (component) => {
  if (!checkProjectFolder) {
    return imagePath + component + fileExtension;
  } else {
    return imagePath + projectNameFromURL + '/' + component + fileExtension;
  }
}

const getScoutLogoFilePath = (routerParams, programs, projects, surveys, component) => {
  setInitialImageFilePathAndProgramFromURL(routerParams);
  setProjectAndSurveyNamesFromURL(routerParams);
  setProgramProjectSurveyObjects(programs, projects, surveys);
  const fileExtension = getFileExtension(component, true);
  if (!fileExtension) {
    return defaultScoutLogoPath;
  } else {
    return imagePath + projectNameFromURL + '/' + component + '.' + fileExtension;
  }
}

export {
  toUpperCase,
  getScoutLogoFilePath,
  showBrandingForComponent,
  getBrandingImageFilePath,
};